import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const GET_LOGGED_IN_USER = gql`
  query GetLoggedInUser {
    loggedInUser {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
